import { render, staticRenderFns } from "./system_version_mangement.vue?vue&type=template&id=099f2eb8&scoped=true&"
import script from "./system_version_mangement.vue?vue&type=script&lang=js&"
export * from "./system_version_mangement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f2eb8",
  null
  
)

export default component.exports